module.exports = __webpack_public_path__ + "img/nol-back.b81d9cf7.png";